import axios from "axios";
import { releaseRequest, trackRequest } from "@/modules/request-queue/request-queue"; // TKP-254: belirteç reaktif değil, istek bitince çıkar

export default {
  async createCancelToken() {
    return trackRequest(axios.CancelToken.source());
  },
  /** TKP-254: istek bitince (başarılı ya da hatalı) belirteç kuyruktan çıkar. */
  async tracked(source, request) {
    try {
      return await request();
    } finally {
      releaseRequest(source);
    }
  },
  defaultOptions(options = {}) {
    return {
      abortOnPageChange: true,
      ...options,
    };
  },
  async post(url, payload, options) {
    const source = this.defaultOptions(options).abortOnPageChange ? await this.createCancelToken() : {};
    return this.tracked(source, () => axios.post(url, payload, {
      cancelToken: source.token,
      headers: options?.headers, // TKP-185 md.74: istek başına başlık (ör. hedef organizasyon) — istek başlığı genel başlığı ezer
    }));
  },
  async put(url, payload, options) {
    const source = this.defaultOptions(options).abortOnPageChange ? await this.createCancelToken() : {};
    return this.tracked(source, () => axios.put(url, payload, {
      cancelToken: source.token,
    }));
  },
  async get(url, options) {
    const source = this.defaultOptions(options).abortOnPageChange ? await this.createCancelToken() : {};
    return this.tracked(source, () => axios.get(url, {
      cancelToken: source.token,
      headers: options?.headers, // TKP-240 b.3: istek başına başlık (görevin organizasyonu) — post/delete gibi
    }));
  },
  async delete(url, options) {
    const source = this.defaultOptions(options).abortOnPageChange ? await this.createCancelToken() : {};
    return this.tracked(source, () => axios.delete(url, {
      cancelToken: source.token,
      headers: options?.headers,
    }));
  },
};
